import { AbstractObjectRegistry } from "../registry/AbstractObjectRegistry";
import { ClientUpdateHandler } from "./ClientUpdateHandler";

export class ClientUpdateHandlerRegistry extends AbstractObjectRegistry<ClientUpdateHandler> {
    private static registry: ClientUpdateHandlerRegistry;

    public static get(): ClientUpdateHandlerRegistry {
        this.initialize();
        return this.registry;
    }

    private static initialize() {
        if (this.registry == null) {
            this.registry = new ClientUpdateHandlerRegistry();
        }
    }
}
